module.exports = __webpack_public_path__ + "fonts/Montserrat-Medium.9d496514.ttf";